// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
}

.sidebar + .ant-layout {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.ant-layout-has-sider {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  overflow: hidden;
}

.sidebar + .ant-layout .ant-layout-content {
  flex: 1 1;
  min-width: 0;
  overflow-y: auto;
}

.ant-layout {
  min-height: 86vh;
  min-height: 0;
}

.ant-layout-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}

.ant-layout-content::-webkit-scrollbar {
  width: 8px;
}

.ant-layout-content::-webkit-scrollbar-track {
  background: transparent;
}

.ant-layout-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 10px;
}

.ant-layout-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.sidebar.ant-layout-sider {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.sidebar .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.sidebar + .ant-layout {
  margin-inline-start: 0 !important;
  padding-inline-start: 0 !important;
}

.sidebar {
  background-color: #2c68ad;
  transition: width 0.25s ease;
  overflow-x: hidden;
  padding: 0;
  flex-shrink: 0;
  position: relative;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.sidebar-hamburger {
  position: fixed;
  top: 12px;
  inset-inline-start: 12px;
  z-index: 1100;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  background: #2c68ad;
  color: #ffffff;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.sidebar-hamburger svg {
  display: block;
}

.sidebar--drawer {
  height: 100%;
}

.sidebar-inner {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.45) rgba(255, 255, 255, 0.12);
}

.sidebar-sections {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

.sidebar-sections::-webkit-scrollbar {
  width: 8px;
}

.sidebar-sections::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 10px;
}

.sidebar-sections::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.45);
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.12);
}

.sidebar-sections::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6);
}

.sidebar-inner.collapsed {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 25px !important;
}

.section-header .collapsed {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px !important;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  margin: 4px 8px;
  transition: background 0.15s ease;
}

.section-header.open {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 8px !important;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin: 4px 8px;
  transition: background 0.15s ease;
}

.section-header.open:hover {
  background: rgba(255, 255, 255, 0.08);
}

.section-header.open .icon {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
}

.section-header.open .label {
  flex: 1 1;
}

.sidebar-icon-img {
  width: 20px;
  height: 20px;
}

.sub-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 8px 10px;
  padding-inline-start: 35px;
  margin: 2px 8px;
  font-size: 12px;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sub-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.item-label {
  font-weight: 500;
}

.item-icon {
  min-width: 20px;
  display: flex;
  justify-content: flex-start;
}

.sub-active {
  background: #2a5f99;
}

.sub-sub-item {
  padding: 6px 16px;
  padding-inline-start: 68px;
  margin: 2px 8px;
  border-radius: 6px;
  font-size: 12.5px;
  color: #eaf1fb;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sub-sub-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.sub-sub-active {
  background: #3a78b8;
  color: #ffffff;
}

.sidebar.collapsed .section-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.sidebar.collapsed .label,
.sidebar.collapsed .sub-item,
.sidebar.collapsed .sub-sub-item {
  display: none;
}

.section-arrow {
  margin-inline-end: 15px;
  font-size: 12px;
  color: #ffffff;
  flex-shrink: 0;
}

.section-header.section-active {
  background: #23538a;
  color: white;
}

.sub-item.sub-active,
.sub-sub-item.sub-sub-active {
  background-color: #23538a;
  color: white;
}

.sub-item.sub-active .item-label,
.sub-sub-item.sub-sub-active .label {
  color: white;
}

.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding: 16px 18px;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease;
}

.sidebar-footer:hover {
  background: rgba(255, 255, 255, 0.08);
}

.sidebar-footer.collapsed {
  justify-content: center;
  padding: 16px;
}

.sidebar-footer__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.home-layout-shell .home-layout-main.responsive-margin,
.home-layout-shell .home-layout-main.header-style {
  margin-left: 0 !important;
}

@media (max-width: 768px) {
  .home-layout-shell .home-layout-main,
  .home-layout-shell .home-layout-main.responsive-margin,
  .home-layout-shell .home-layout-main.header-style {
    margin-left: 0 !important;
    width: 100% !important;
  }
  .home-layout-shell .ant-layout-content {
    margin-inline-start: 0 !important;
    padding-inline-start: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/HomePage/SidebarManagement/Sidebar.scss"],"names":[],"mappings":"AAAA;;;EAGE,YAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AACF;;AACA;EACE,gBAAA;EACA,aAAA;AAEF;;AAAA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAGF;;AAAA;EACE,UAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AAAA;EACE,+BAAA;EACA,mBAAA;AAGF;;AAAA;EACE,8BAAA;AAGF;;AAAA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAGF;;AAAA;EACE,iCAAA;EACA,kCAAA;AAGF;;AAAA;EACE,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAGF;;AAAA;EACE,eAAA;EACA,SAAA;EACA,wBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;AAGF;;AAAA;EACE,cAAA;AAGF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,oEAAA;AAGF;;AAAA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AAGF;;AAAA;EACE,UAAA;AAGF;;AAAA;EACE,qCAAA;EACA,mBAAA;AAGF;;AAAA;EACE,qCAAA;EACA,mBAAA;EACA,2CAAA;AAGF;;AAAA;EACE,oCAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAGF;;AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAGF;;AAAA;EACE,qCAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAGF;;AAAA;EACE,SAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AAGF;;AAAA;EACE,qCAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,eAAA;EACA,aAAA;EACA,2BAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;;AAFA;EACE,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AAKF;;AAFA;EACE,qCAAA;AAKF;;AAFA;EACE,mBAAA;EACA,cAAA;AAKF;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAKF;;AAFA;;;EAGE,aAAA;AAKF;;AAFA;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAKF;;AAFA;EACE,mBAAA;EACA,YAAA;AAKF;;AAFA;;EAEE,yBAAA;EACA,YAAA;AAKF;;AAFA;;EAEE,YAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAKF;;AAFA;EACE,qCAAA;AAKF;;AAFA;EACE,uBAAA;EACA,aAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAKF;;AAFA;;EAEE,yBAAA;AAKF;;AAFA;EACE;;;IAGE,yBAAA;IACA,sBAAA;EAKF;EAFA;IACE,iCAAA;IACA,kCAAA;EAIF;AACF","sourcesContent":["html,\r\nbody,\r\n#root {\r\n  height: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.sidebar + .ant-layout {\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.ant-layout-has-sider {\r\n  min-height: 100vh;\r\n  height: 100vh;\r\n  display: flex;\r\n  overflow: hidden; \r\n}\r\n\r\n.sidebar + .ant-layout .ant-layout-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow-y: auto;\r\n}\r\n.ant-layout {\r\n  min-height: 86vh;\r\n  min-height: 0;\r\n}\r\n.ant-layout-content {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.18);\r\n  border-radius: 10px;\r\n}\r\n\r\n.ant-layout-content::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.sidebar.ant-layout-sider {\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar .ant-layout-sider-children {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n.sidebar + .ant-layout {\r\n  margin-inline-start: 0 !important;\r\n  padding-inline-start: 0 !important;\r\n}\r\n\r\n.sidebar {\r\n  background-color: #2c68ad;\r\n  transition: width 0.25s ease;\r\n  overflow-x: hidden;\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n  height: 100vh;\r\n  max-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sidebar-hamburger {\r\n  position: fixed;\r\n  top: 12px;\r\n  inset-inline-start: 12px;\r\n  z-index: 1100;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: #2c68ad;\r\n  color: #ffffff;\r\n  font-size: 20px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.sidebar-hamburger svg {\r\n  display: block;\r\n}\r\n\r\n.sidebar--drawer {\r\n  height: 100%;\r\n}\r\n\r\n.sidebar-inner {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.45) rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.sidebar-sections {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar-track {\r\n  background: rgba(255, 255, 255, 0.12);\r\n  border-radius: 10px;\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.45);\r\n  border-radius: 10px;\r\n  border: 2px solid rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.sidebar-sections::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.sidebar-inner.collapsed {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.sidebar-logo {\r\n  height: 64px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  margin-top: 25px !important;\r\n}\r\n\r\n.section-header .collapsed {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 18px !important;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  margin: 4px 8px;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.section-header.open {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 6px 8px !important;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  margin: 4px 8px;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.section-header.open:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.section-header.open .icon {\r\n  width: 15px;\r\n  height: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 10px;\r\n}\r\n\r\n.section-header.open .label {\r\n  flex: 1;\r\n}\r\n\r\n.sidebar-icon-img {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.sub-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 8px 8px 10px;\r\n  padding-inline-start: 35px;\r\n  margin: 2px 8px;\r\n  font-size: 12px;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.sub-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.item-label {\r\n  font-weight: 500;\r\n}\r\n.item-icon {\r\n  min-width: 20px;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n.sub-active {\r\n  background: #2a5f99;\r\n}\r\n\r\n.sub-sub-item {\r\n  padding: 6px 16px;\r\n  padding-inline-start: 68px;\r\n  margin: 2px 8px;\r\n  border-radius: 6px;\r\n  font-size: 12.5px;\r\n  color: #eaf1fb;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.sub-sub-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.sub-sub-active {\r\n  background: #3a78b8;\r\n  color: #ffffff;\r\n}\r\n\r\n.sidebar.collapsed .section-header {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 16px;\r\n}\r\n\r\n.sidebar.collapsed .label,\r\n.sidebar.collapsed .sub-item,\r\n.sidebar.collapsed .sub-sub-item {\r\n  display: none;\r\n}\r\n\r\n.section-arrow {\r\n  margin-inline-end: 15px;\r\n  font-size: 12px;\r\n  color: #ffffff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.section-header.section-active {\r\n  background: #23538a;\r\n  color: white;\r\n}\r\n\r\n.sub-item.sub-active,\r\n.sub-sub-item.sub-sub-active {\r\n  background-color: #23538a;\r\n  color: white;\r\n}\r\n\r\n.sub-item.sub-active .item-label,\r\n.sub-sub-item.sub-sub-active .label {\r\n  color: white;\r\n}\r\n\r\n.sidebar-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-shrink: 0;\r\n  padding: 16px 18px;\r\n  margin-top: auto;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.18);\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.sidebar-footer:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.sidebar-footer.collapsed {\r\n  justify-content: center;\r\n  padding: 16px;\r\n}\r\n\r\n.sidebar-footer__icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.home-layout-shell .home-layout-main.responsive-margin,\r\n.home-layout-shell .home-layout-main.header-style {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .home-layout-shell .home-layout-main,\r\n  .home-layout-shell .home-layout-main.responsive-margin,\r\n  .home-layout-shell .home-layout-main.header-style {\r\n    margin-left: 0 !important;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .home-layout-shell .ant-layout-content {\r\n    margin-inline-start: 0 !important;\r\n    padding-inline-start: 0 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
